"use client";
import { createContext } from "react";
export const LayoutGroupContext = createContext({});
//# sourceMappingURL=LayoutGroupContext.js.map